// extracted by mini-css-extract-plugin
export default {"requests":"Requests_requests__88xlS","chartRow":"Requests_chartRow__sOU3O","chart":"Requests_chart__5n1sj"};